module.exports = __webpack_public_path__ + "img/CS48Q-中_01.a244ea4c.jpg";